import React from 'react';
import { X } from 'lucide-react';

const FILTER_LABELS = {
  age_lte: (v) => `Âge ≤ ${v} ans`,
  nb_joueurs: (v) => `${v} joueurs`,
  temps_max: (v) => `≤ ${v} min`,
  pvc_min: (v) => `PVC ≥ ${v}€`,
  pvc_max: (v) => `PVC ≤ ${v}€`,
  public_cible: (v) => Array.isArray(v) ? v.join(', ') : v,
  type_jeu: (v) => Array.isArray(v) ? v.join(', ') : v,
  tags_produit_ids: () => 'Tags Produit',
  partner_id: () => 'Distributeur',
  editeur: (v) => `Éditeur: ${v}`,
};

/**
 * ActiveFiltersChips — Barre de chips des filtres actifs (Phase 3.4)
 */
export default function ActiveFiltersChips({ filters, onClear, onClearAll, tagsMap = {} }) {
  const entries = Object.entries(filters).filter(([, v]) => {
    if (Array.isArray(v)) return v.length > 0;
    return v !== undefined && v !== null && v !== '';
  });

  if (entries.length === 0) return null;

  const getLabel = (key, value) => {
    if (key === 'tags_produit_ids' && Array.isArray(value)) {
      const labels = value.map(id => tagsMap[id] || id).slice(0, 3);
      return labels.join(', ') + (value.length > 3 ? ` +${value.length - 3}` : '');
    }
    const fn = FILTER_LABELS[key];
    return fn ? fn(value) : `${key}: ${value}`;
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="active-filters-chips">
      {entries.map(([key, value]) => (
        <button
          key={key}
          onClick={() => onClear(key)}
          className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200 rounded-full hover:bg-gray-200 transition-colors"
          data-testid={`chip-${key}`}
        >
          {getLabel(key, value)}
          <X className="h-3 w-3" />
        </button>
      ))}
      {entries.length > 1 && (
        <button
          onClick={onClearAll}
          className="text-xs text-gray-500 hover:text-gray-700 underline ml-1"
          data-testid="clear-all-filters"
        >
          Tout effacer
        </button>
      )}
    </div>
  );
}
